export default "__VITE_ASSET__3b8d914b__"